var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('router-link',{attrs:{"to":_vm.router}},[_c('the-language',{attrs:{"de":_vm.de,"en":_vm.en}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }